import * as React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { getSearchQuery } from '../utils/globals';
import { parseUrl, stringifyUrl } from 'query-string';

type RouterLinkProps = LinkProps & {
  'data-test-id'?: string;
  to: string;
};

/**
 * Strip out 'query' from url search query params
 */
const withoutSearchQuery = (): string => {
  const searchQuery = getSearchQuery();
  if (searchQuery.length) {
    let parsedSearchQuery = parseUrl(window.location.search);
    delete parsedSearchQuery.query['query'];
    return stringifyUrl(parsedSearchQuery);
  }
  return window.location.search;
};

const RouterLink: React.FC<RouterLinkProps> = ({
  'data-test-id': dataTestId,
  children,
  to: pathname,
  ...props
}) => {
  const search = withoutSearchQuery();
  return (
    <Link to={{ pathname, search }} data-testid={dataTestId} {...props}>
      {children}
    </Link>
  );
};

export default RouterLink;
